import { useParams } from 'react-router-dom';
import CompanyPage from './CompanyPage';
import FormWrapper from './FormWrapper';
import { useLayoutContext } from 'contexts/LayoutContext';
import PageLoader from 'components/PageLoader';
import api from 'lib/trpcClient';

const AddEditCompany: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const { vehicle } = useLayoutContext();

  const { data: company, isLoading: isCompanyLoading } =
    api.lpCompany.get.useQuery(
      {
        companyId: id ?? '',
        vehicleId: vehicle?._id ?? '',
      },
      {
        enabled: !!id && !!vehicle?._id,
      },
    );

  if (isCompanyLoading || !vehicle) {
    return <PageLoader />;
  }

  return (
    <FormWrapper
      selectedVehicle={vehicle}
      values={
        company
          ? {
              ...company,
              sector: company.sector ?? undefined,
              stage: company.stage ?? undefined,
            }
          : undefined
      }
    >
      <CompanyPage
        selectedVehicle={vehicle}
        company={
          company
            ? {
                id: company._id,
                name: company.name,
                logoUrl: company.companyLogo?.preview,
              }
            : undefined
        }
      />
    </FormWrapper>
  );
};

export default AddEditCompany;
